import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import './Publications.css';

const publications = [
    {
        title: "Port of Brownsville Floating Breakwater",
        url: "/uploads/port_of_brownsville_floating_breakwater.pdf",
    },
    {
        title: "Combined Wave – Iceberg Loading on Offshore Structures",
        url: "/uploads/combined_wave.pdf",
    },
    {
        title: "Reliability Calibration of a Wave – Icebergs Interaction Load Combination Factor",
        url: "/uploads/reliability_calibration_of_a_wave.pdf",
    },
    {
        title: "Assessment of the Wave – Iceberg Load Combination Factor",
        url: "/uploads/assessment_of_the_wave.pdf",
    },
    {
        title: "Ridge Loads on Wind Turbine Structures",
        url: "/uploads/ridge_loads_on_wind_turbine_structures.pdf",
    },
    {
        title: "Three-Dimensional Modeling of the Ruwais Coastal Area of UAE",
        url: "/uploads/3D_modeling_of_ruwais_coastal_area.pdf"
    },
    {
        title: "Effect of Cyclone Track on Storm Surges in the Bay of Bengal",
        url: "/uploads/bay_of_bengal_cyclone_track.pdf"
    },
    {
        title: "Cyclone Storm Surge Levels Along the Bangladeshi Coastline",
        url: "/uploads/bay_of_bengal_storm_surge.pdf"
    },
    {
        title: "Hydrodynamic Characterization and Modelling of the Arabian Gulf",
        url: "/uploads/hydrodynamic_modelling_arabian_gulf.pdf"
    }
];

const Publications = () => {
    return (
        <div className="publications-container">
            <ul className="publication-list">
                {publications.map((pub, index) => (
                    <li key={index} className="publication-item">
                        <FontAwesomeIcon icon={faFilePdf} className="publication-icon" />
                        <div className="publication-info">
                            <div className="publication-title">{pub.title}</div>
                            <a href={pub.url} target="_blank" rel="noopener noreferrer" className="download-link"> Download File </a>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Publications;